const state = {
    CROP_TYPES: [],
};

const getters = {
    _CROP_TYPES: state => {
        return state.CROP_TYPES;
    }
};


const mutations = {
    UpdateCropTypes: (state, payload) => {
        state.CROP_TYPES = payload;
    }
};


const actions = {
    UpdateCropTypes ({ commit }, payload) {

        commit('UpdateCropTypes', payload);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};